import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import localeFr from '@angular/common/locales/fr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmMailComponent } from './confirm-mail/confirm-mail.component';
import { HttpInterceptorCAS } from './home/interceptor/httpInterceptorCAS';
import { ReinitPasswordComponent } from './reinit-password/reinit-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthComponent } from './auth/auth.component';
registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    ConfirmMailComponent,
    ReinitPasswordComponent,
    AuthComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ToastrModule.forRoot()
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorCAS, multi: true},
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    BnNgIdleService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
